import { Box, Typography } from "@bca/ui-library";
import React from "react";
import styled from "styled-components";

interface ReportTitleProps {
  title: string;
}

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ReportTitle: React.FunctionComponent<ReportTitleProps> = ({
  children,
  title,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <StyledBox>
        {children}
        <Typography
          variant="body-small"
          color="footer-blue"
          fontWeight="medium"
          m={0}
        >
          {title}
        </Typography>
      </StyledBox>
    </Box>
  );
};

export default ReportTitle;
